/*
 * antd v5 只支持 React 16~18，本项目是 React 19。缺这个补丁时静态方法
 * （message.xxx() / notification / Modal.confirm）走已被移除的 ReactDOM.render，
 * 静默失效、一个 DOM 节点都不渲染——代码照常执行，界面上什么都没有。
 *
 * 必须放在所有 antd 引用之前。组件内仍推荐 App.useApp() / messageHolder，这里只是兜底。
 */
import '@ant-design/v5-patch-for-react-19';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ApolloProvider } from '@apollo/client';
import { ConfigProvider, App as AntdApp } from 'antd';
import enUS from 'antd/locale/en_US';
import zhCN from 'antd/locale/zh_CN';
import esES from 'antd/locale/es_ES';
import './index.css';
import App from './App';
import { PermissionProvider } from './components/PermissionProvider';
import { client } from './graphql/client';
import { theme } from './theme';
import './i18n';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
import 'dayjs/locale/es';
import 'dayjs/locale/en';

const getAntdLocale = (lang: string) => {
    switch (lang) {
        case 'zh':
            dayjs.locale('zh-cn');
            return zhCN;
        case 'es':
            dayjs.locale('es');
            return esES;
        default:
            dayjs.locale('en');
            return enUS;
    }
};

const ResponsiveConfigProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const { i18n } = useTranslation();
    const currentLang = (i18n.resolvedLanguage || i18n.language || 'en').toLowerCase().split('-')[0];
    const antdLocale = getAntdLocale(currentLang);

    return (
        <ConfigProvider
            locale={antdLocale}
            theme={theme}
            form={{
                requiredMark: (label, { required }) => (
                    <>
                        {label}
                        {required && <span className="text-red-500 ml-1">*</span>}
                    </>
                ),
            }}
        >
            {children}
        </ConfigProvider>
    );
};

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

root.render(
    <React.StrictMode>
        <ApolloProvider client={client}>
            <ResponsiveConfigProvider>
                <AntdApp>
                    <BrowserRouter basename="/ClientCenter">
                        <PermissionProvider>
                            <App />
                        </PermissionProvider>
                    </BrowserRouter>
                </AntdApp>
            </ResponsiveConfigProvider>
        </ApolloProvider>
    </React.StrictMode>
);
